/**
 * MSAL Constants
 * Stores information related Microsoft Authentication Library.
 */
export const MSALConstants = Object.freeze({
    SCOPES: {
        BUILDE_READ: 'https://BuildEB2C.onmicrosoft.com/buildeapidev/Builde.read'
    },
    AUTH: {
        CONFIGURATION: {
            auth: {
                clientId: `${process.env.REACT_APP_MSAL_AUTH_CLIENT_ID}`,
                authority: `${process.env.REACT_APP_MSAL_AUTH_AUTHORITY}`,
                knownAuthorities: [`${process.env.REACT_APP_MSAL_AUTH_KNOWN_AUTHORITY_BUILDEB2C}`]
            },
            BASE_AUTHORITY: `${process.env.REACT_APP_MSAL_AUTH_BASE_AUTHORITY}`,
            SIGNUP_AUTHORITY: `${process.env.REACT_APP_MSAL_AUTH_SIGNUP_AUTHORITY}`,
        }
    }
})